// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Lzzks","title":"Header_title__2YcAl","left":"Header_left__12Vcg","clinicName":"Header_clinicName__3CLg_"};